import { useContext } from "react"
import { GetApp } from "../../App"
import { PrintShipViewContext, ShipDataType } from "../../App/Context"
import { BlockField, BlockRow } from "../../Components/Block"
import { PrintListBlock } from "../../Components/PrintListBlock"
import { PrintShipViewData } from "./Context"
import { PrintShipOtherEquipmentViewProps } from "./Params"

// Free-text other equipment. Detail-level section, only rendered when non-empty.
export function PrintShipOtherEquipmentView({ data }: PrintShipOtherEquipmentViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const { shipData } = PrintShipViewData.resolveShipData(data);

  const context = useContext(PrintShipViewContext);
  const includeShipDataType = context?.includeShipDataType || ShipDataType.short;
  const visible = !!(includeShipDataType === ShipDataType.details && shipData?.otherEquipments && shipData.otherEquipments.length > 0);

  return (
    <PrintListBlock title={t("other_equipment")} visible={visible}>
      {shipData?.otherEquipments && shipData.otherEquipments.length > 0 && shipData.otherEquipments.map((otherEquipment, index) => (
        <BlockRow key={otherEquipment.id || index} className="block-row-last">
          <BlockField className="block-field-270">{otherEquipment.equipment} </BlockField>
        </BlockRow>
      ))}
    </PrintListBlock>
  );
}
